import { Box, Typography } from "@mui/material";
import { CurrentUser } from "protogen/auth_pb";

interface WelcomeHeaderProps {
  user: CurrentUser;
}

const WelcomeHeader = ({ user }: WelcomeHeaderProps) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Typography variant="h3" sx={{ fontWeight: 500, textWrap: "nowrap" }}>
          Welcome back,{" "}
        </Typography>
        <Typography variant="display" sx={{ fontSize: "32px" }}>
          {user.firstName} {user.lastName}
        </Typography>
      </Box>
    </Box>
  );
};

export default WelcomeHeader;
